import { assertNever } from "@impero-com/common/utils/obj";

import { ConfirmationStep } from "./components/confirmationStep";
import { ExportStep } from "./components/exportStep";
import { UploadStep } from "./components/uploadStep";
import { useSpreadsheetProcessor } from "./hooks/useSpreadsheetProcessor";
import * as theme from "./theme.css";

export type BulkImportStep = "export" | "upload" | "confirm";

interface BulkImportStepsContainerProps {
    currentStep: BulkImportStep;
    onStepChange: (step: BulkImportStep) => void;
    onErrorChange: (hasError: boolean) => void;
}

export function BulkImportStepsContainer({
    currentStep,
    onStepChange,
    onErrorChange,
}: BulkImportStepsContainerProps) {
    const { processedData, validationErrors, processFile, resetData } =
        useSpreadsheetProcessor();

    const renderStep = () => {
        switch (currentStep) {
            case "export":
                return <ExportStep onStepChange={onStepChange} />;
            case "upload":
                return (
                    <UploadStep
                        onStepChange={onStepChange}
                        onErrorChange={onErrorChange}
                        validationErrors={validationErrors}
                        processFile={processFile}
                        resetData={resetData}
                    />
                );
            case "confirm":
                if (!processedData) {
                    throw new Error(
                        "Invalid state: Reached confirmation step without processed data"
                    );
                }

                if (!processedData.success) {
                    throw new Error(
                        "Invalid state: Reached confirmation step with unsuccessful data processing"
                    );
                }

                return (
                    <ConfirmationStep
                        controls={processedData.controlGraphs}
                        onStepChange={onStepChange}
                    />
                );
            default:
                return assertNever(currentStep);
        }
    };

    return (
        <div className={theme.pageContent}>
            <div className={theme.stepContent}>{renderStep()}</div>
        </div>
    );
}
